import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { useNavigate } from 'react-router'

export const UsersHeader = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  const title = t('users', 'Users')

  return (
    <Header
      title={title}
      position='relative'
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => navigate('new')}
          data-cy='add-user-btn'
        >
          {t('addUser', 'Add user')}
        </Button>
      }
    />
  )
}
